<template>
  <div>

    <!--
     'canExport' flag can be used to set if the datatable can be exported or not it adds a button on the top right of the datatable
    @exportCSV expects the name of the function that is to be triggered when the user clicks on the Export button.
    -->
    <div class="md-layout md-layout-item scrolls">
      <div
      v-for="(application, key) in display_items"
        :key="key"
        class="boxed-category md-layout-item md-medium-size-25 md-small-size-33 md-size-15"
      >
        <md-subheader class="text-bold">
          <div>
            {{ key }}
          </div>
          <div class="application-count">
            <md-icon>description</md-icon>
            {{ application.length }}
          </div>
        </md-subheader>
      </div>
    </div>

    <data-table
      :headers="display_headers"
      v-model="applications"
      :items-per-page="50"
      filterable
      :canExport="canExport"
      @exportCSV="exportCSV"
      editable-columns
      @double-click="triggerEdit($event)"
      @refresh-data="$emit('refresh-data')"
      title="Applications on your list"
      :stickyheader="stickyHeader"
      :backend-pagination="backendPagination"
      :external-data-refresh="externalDataRefresh"
      :external-loading-pagination="externalLoadingPagination"
    >

      <template v-slot:item.id="{ item }">
        <span>
          <md-tooltip md-direction="top">{{item.asset_type}}</md-tooltip>
          <md-icon>{{mapAssetType(item.asset_type)}}</md-icon>

          <md-tooltip md-direction="left">{{item.applicant_type}}</md-tooltip>
          <md-icon>{{mapApplicantType(item.applicant_type)}}</md-icon>
          {{ item.id }}
        </span>
      </template>

      <template v-slot:item.agent="{ item }">
        <div class="md-layout" v-if="item.owners.Agent">
          <md-tooltip md-direction="top">
            <span v-if="item.owners.Agent.pod.name">Pod: {{ name(item.owners.Agent.pod.name) }}</span>
            <span v-if="item.owners.Agent.user.phone_number && name(item.owners.Agent.pod.name) !== 'Call Centre'">
              Phone: {{ name(item.owners.Agent.user.phone_number) }}
            </span>
          </md-tooltip>
          {{ name(item.owners.Agent.user.name) }}
        </div>
      </template>

      <template v-slot:item.user="{ item }">
        <div class="md-layout" v-if="item.owners.Broker">
          <md-tooltip md-direction="top">
            <span v-if="item.owners.Broker.pod.name">Pod: {{ name(item.owners.Broker.pod.name) }}</span></br>
            <span v-if="item.owners.Broker.user.phone_number">Phone: {{ name(item.owners.Broker.user.phone_number) }}</span>
          </md-tooltip>
          {{ name(item.owners.Broker.user.name) }}
        </div>
      </template>

      <template v-slot:item.document_status="{ item }">
            <span style="display:flex; justify-content:space-evenly;">
              <span>
                <md-tooltip md-direction="left">ID Docs</md-tooltip>
                <md-icon class="md-icon md-icon-font md-theme-default" :style="item.badge_flag == 1 ? {'color' : '#4caf50'} : {'color' : '#696969'}">badge</md-icon>

                <md-tooltip md-direction="right">Financial Docs</md-tooltip>
                <md-icon class="md-icon md-icon-font md-theme-default" :style="item.request_quote_flag == 1 ? {'color' : '#4caf50'} : {'color' : '#696969'}">request_quote</md-icon>

                <md-icon class="round-pink-background" v-if="item.voi.grade">attach_money</md-icon>
              </span>
            </span>
      </template>

      <template v-slot:header_totals>
            <span><strong>Total Income: </strong> {{totalNafAndIncome.totalIncomes | currency}} </span>
            <span><strong>Total NAF: </strong> {{totalNafAndIncome.totalNaf | currency}} </span>
      </template>

      <template v-slot:item.finalized_status="{ item }">
        <div class="md-layout" v-if="item.finalized_status == 'finalized'">
          <md-tooltip md-direction="top">Income Finalized</md-tooltip>
          <md-icon class="md-icon md-primary md-alignment-center">check_circle</md-icon>
        </div>
        <div class="md-layout" v-else-if="item.finalized_status == 'not finalized'">
          <md-tooltip md-direction="top">Income not Finalized</md-tooltip>
          <md-icon class="md-icon md-alignment-center orange-icon">warning</md-icon>
        </div>
        <div class="md-layout" v-else-if="item.finalized_status == 'others'"></div>
      </template>

      <template v-slot:item.actions="{ item }" v-if="!isFromHubspot()">
        <md-menu md-size="medium" md-direction="bottom-start" class="action-menu" @click="getAppPermissions(item)">
          <loading-icon-button md-menu-trigger tooltip="Click the 3 dots to see more" style="margin: 5px 1px">
            more_vert
          </loading-icon-button>

          <md-menu-content class="action-menu">
            <md-menu-item @click="triggerEdit(item)" v-if="!isDisabled(actions.update, item)"
              >
              <md-tooltip md-direction="left">Edit the loan application</md-tooltip>
              <md-icon>edit</md-icon>
              Edit Application
            </md-menu-item>
            <md-menu-item @click="triggerOpen(item)" tooltip="Open Summary" v-if="!isDisabled(actions.view, item)"
              >
              <md-tooltip md-direction="left">Go to the loan application summary page</md-tooltip>
              <md-icon>launch</md-icon>
              Open Summary
            </md-menu-item>
            <md-menu-item
              @click="triggerUpdateStatus(item)"
              v-if="!isDisabled(actions.update_status, item)"
              >
              <md-tooltip md-direction="left">Update the status of the application</md-tooltip>
              <md-icon>update</md-icon>
              Update Status
            </md-menu-item>
            <md-menu-item
              @click="triggerManageOwners(item)"
              v-if="!isDisabled(actions.transfer, item)"
              >
              <md-tooltip md-direction="left">Manage the loan application owners</md-tooltip>
              <md-icon>manage_accounts</md-icon>
              Manage Owners
            </md-menu-item>
            <md-menu-item
              @click="triggerAttachment(item)"
              >
              <md-tooltip md-direction="left">Manage application documents</md-tooltip>
              <md-icon>attach_file</md-icon>
              Attachments
            </md-menu-item>
            <md-menu-item @click="triggerManageComment(item)">
              <md-tooltip md-direction="left">Manage the loan application comments</md-tooltip>
              <md-icon>comment</md-icon>
              Manage Comment
            </md-menu-item>
            <md-menu-item @click="triggerCloneApplication(item)">
              <md-tooltip md-direction="left">Clone Application</md-tooltip>
              <md-icon>file_copy</md-icon>
              Clone Application
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </template>
      <template v-slot:item.actions="{ item }" v-else>
        <md-menu md-size="medium" md-direction="bottom-start" class="action-menu">
          <loading-icon-button md-menu-trigger tooltip="Click the 3 dots to see more" style="margin: 5px 1px">
            more_vert
          </loading-icon-button>

          <md-menu-content class="action-menu">
            <md-menu-item @click="triggerRetrieveFromHubspot(item)">
              <md-tooltip md-direction="left">Retrieve from Hubspot</md-tooltip>
              <md-icon>file_copy</md-icon>
              Retrieve from Hubspot
            </md-menu-item>
          </md-menu-content>
        </md-menu>
      </template>
    </data-table>
  </div>
</template>
<script>
import LoadingIconButton from "@/components/LoadingIconButton";
import DataTable from "@/components/DataTable";
import WaitingDialog from "@/components/Dialogs/WaitingDialog";
import filters from "@/components/utils/filters";
import {mapGetters} from "vuex";

export default {
  components: {
    LoadingIconButton,
    DataTable,
  },
  data() {
    return {
      searchQuery: "",
      applicationBasedOnStatus: {},
      appStages: ["New", "Call Centre", "Doc Collection", "Broker", "Settlement", "Compliance"],
      stickyHeader: true,
      actions: {
        update: "update",
        view: "view",
        transfer: "transfer",
        update_status: "update-status",
        archive: "archive",
        un_archive: "un-archive",
        manage_owners: "manage-owners",
        attachments:"attachments",
        comment: "comment",
        clone: "clone",
      },
      headers: [
        {
          text: "ID",
          value: "id",
          sort: false,
          width: '100px',
          classFunction(item) {
            let age_in_days = filters.ageInDays(item.created_at);
            if (age_in_days > 14) return 'days_red';
            if (age_in_days > 7) return 'days_amber';
            if (age_in_days > 3) return 'days_light_green';
            return [];
          },
          search: true
        },
        /*{
          text: "Date In",
          value: "created_at",
          filter: filters.dateonly,
          sort: false,
          width: '92px',
        }, */
        {
          text: "Pod Date",
          value: "pod_date",
          filter: filters.dateonly,
          sort: false,
          width: '92px',
        },
        {
          text: "Stage / Status",
          value: "stage_status",
          search: true,
          sort: false,
          width: '10%',
          valueFunction(item) {
            return `${item.status.stage} / ${item.status.status}`;
          },
        },
        {
          text: "Agent",
          value: "agent",
          inputtype: "text",
          valueFunction(item) {
            return filters.name(item.owners.Agent && item.owners.Agent.user.name);
          },
          search: true,
          sort: false,
          width: '10%',
        },
        {
          text: "Broker",
          value: "user",
          inputtype: "text",
          valueFunction(item) {
            return filters.name(item.owners.Broker && item.owners.Broker.user.name);
          },
          search: true,
          sort: false,
          width: '10%',
        },
        {
          text: "Status Date",
          value: "status_date",
          valueFunction(item) {
            return filters.dateonly(item.status.status_date);
          },
          inputtype: "date",
          sort: -1,
          width: '92px',
        },
        {
          text: "Referrer",
          value: "introducer",
          inputtype: "text",
          valueFunction(item) {
            return filters.name(item.owners.Referrer && item.owners.Referrer.user.name)
          },
          sort: false,
          search: true,
          width: '10%',
        },
        {
          text: "Lender",
          value: "lender_name",
          inputtype: "text",
          sort: false,
          search: true,
          width: '8%',
        },
        {
          text: "Name",
          value: "name",
          inputtype: "text",
          valueFunction(item) {
            if (Array.isArray(item.name)) {
              return (item.name).map(names => `${filters.name(names)}`).join(", ");
            } else {
              return item.name;
            }
          },
          sort: false,
          search: true,
          width: '15%',
        },
        {
          text: "Phone",
          value: "phone",
          valueFunction(item) {
            return `${item.contact_details.phone_number}`;
          },
          classFunction() {
            return 'work-basket-overflow-item';
          },
          search: true,
          width: '10%',
        },
        {
          text: "Email",
          value: "email",
          valueFunction(item) {
            return item.contact_details.email;
          },
          classFunction() {
            return 'work-basket-overflow-item';
          },
          search: true,
          width: '20%',
        },
        {
          text: "Comment",
          value: "comment",
          // single_line: true,
          classFunction() {
            return 'work-basket-comment';
          },
          width: '15%',
          search: true
        },
        {
          text: "Income",
          value: "income",
          valueFunction(item) {
            let totalIncome = 0;
            if (item.broker_incomes) {
              totalIncome = item.broker_incomes.reduce((sum, current) => sum + parseFloat(current.income_amount), 0);
            }
            if (item.insurances) {
              totalIncome = totalIncome + item.insurances.reduce((sum, current) => sum + ((current.income && current.enabled) ? parseFloat(current.income.replace(/,/g, '')) : 0), 0);
            }
            return filters.currency(totalIncome);
          },
          width: '10%',
          search: true,
        },
        {
          text: "NAF",
          value: "naf",
          width: '10%',
          search: true,
        },
        {
          text: "Document Status",
          value: "document_status",
          width: '12%',
          valueFunction(item) {
            if (item.badge_flag === 1 && item.request_quote_flag === 1) return 3;
            else if (item.badge_flag === 0 && item.request_quote_flag === 1) return 2;
            else if (item.badge_flag === 1 && item.request_quote_flag === 0) return 1;
            return 0;
          },
          sort: false
        },
        {
          text: "Finalised",
          value: "finalized_status",
          width: '50px',
        },
        {
          text: "Veda score 2.0",
          value: "veda_score",
          width: '10%',
        },
        {
          text: "",
          value: "actions",
          align: "right",
          width: '45px',
          optional: false,
        },
      ],
      totalIncomes: 0,
      totalNaf :0,
    };
  },
  props: {
    filterable: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: null,
      default: () => null,
    },
    showIntroducer: {
      type: Boolean,
      default: false,
    },
    canExport: {
      type: Boolean,
      default: false,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
    backendPagination: {
      type: Boolean,
      default: false,
    },
    externalDataRefresh: {
      type: Boolean,
      default: false
    },
    externalLoadingPagination: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["userHasPermission", "current_lock", "agent_has_visibility_subscription"]),
    applications() {
      if (this.items) {
        this.items.forEach(item => {
          switch (item.status.status) {
            case 'Assigned To Broker':
              item.tr_class="bg-blue"
              break;
            case 'In Progress':
              // Just apply for Broker - In progress
              if (item.status.stage === "Broker") {
                item.tr_class="bg-yellow-light";
                break;
              }
            case 'Submitted':
              item.tr_class="bg-orange-light"
              break;
            case 'Approved':
              item.tr_class="bg-green-light"
              break;
            case 'Fail':
              item.tr_class="bg-red-light"
              break;
            case 'Waiting for Docs':
              item.tr_class="bg-blue"
              break;
            default:
              item.tr_class="bg-white"
          }

          // three situation 1. finalized, 2. not finalized, 3. others
          if (item.is_finalized) {
            item.finalized_status = 'finalized';
          } else if (item.status.stage === 'Compliance' || (item.status.stage === 'Settlement' && item.status.status === 'Settled')) {
            item.finalized_status = 'not finalized';
          } else {
            item.finalized_status = 'others';
          }
        })
        return this.items;
      } else {
        return [];
      }
      return this.items ? this.items : [];
    },

    totalNafAndIncome() {
        let total = {
            totalNaf : 0,
            totalIncomes : 0,
        }
        this.items.forEach(item=>{
            if( item.broker_incomes ) {
                 total.totalIncomes = total.totalIncomes +  item.broker_incomes.reduce((sum, current) => sum + parseFloat(current.income_amount), 0);
            }
            if( item.naf ) {
                total.totalNaf = total.totalNaf + parseFloat(item.naf);
            }
        });
        return total;
    },

    display_items() {
      for (let stage of this.appStages) {
            const applicationWithStatus = {};
            applicationWithStatus[stage] = this.applications.filter( application => application.status.stage == stage);
            this.applicationBasedOnStatus = {...this.applicationBasedOnStatus, ...applicationWithStatus};
          }
          return this.applicationBasedOnStatus;
    },

    display_headers() {
      if (this.agent_has_visibility_subscription) {
        return this.headers.filter(header => header.text !== 'Income');
      }
      return this.headers;
    },
  },
  methods: {
    ...filters,
      mapAssetType(asset_type_name) {
        switch (asset_type_name.toLowerCase().trim()) {
          case 'vehicle':
            return 'directions_car_filled';
          case 'marine':
            return 'directions_boat';
          case 'cashflow':
            return 'attach_money';
          case 'equipment':
            return 'handyman';
          case 'leisure':
            return 'rv_hookup';
          case 'personal secured':
            return 'lock';
          case 'personal unsecured':
            return 'lock_open';
          default:
            return;
        }
      },
      mapApplicantType (applicant_type_name) {
        switch (applicant_type_name.toLowerCase().trim()) {
          case 'consumer':
            return 'account_circle';
          case 'sole trader':
            return 'man';
          case 'partnership - abn':
            return 'supervised_user_circle';
          case 'company':
            return 'business';
          case 'trust':
            return 'real_estate_agent';
          default:
            return;
        }
    },
    async getAppPermissions(items){
      let result = await axios.get(`/api/v1/application/${items.id}/getPermissions`);
      items.permissions = result.data;
    },
    visibleItemsChange(items){
        this.totalIncomes = 0;
        this.totalNaf = 0;
        items.forEach(item=>{
            if(item.broker_incomes) {
                 this.totalIncomes = this.totalIncomes +  item.broker_incomes.reduce((sum, current) => sum + parseFloat(current.income_amount), 0);
            }
            if(item.naf) {
                this.totalNaf = this.totalNaf + parseFloat(item.naf);
            }
        })
    },
    exportCSV(){
      //here the button calls the function that lies in the parent component
      this.$emit('export-csv');
    },
    isLoading(action, application) {
      return (
        this.loading && this.loading.action == action && this.loading.application == application
      );
    },
    isDisabled(action, application) {
      if (this.loading) return true;
      return !application.permissions[action];
    },
    async triggerEdit(application) {
      await this.getAppPermissions(application);
      if (application.permissions[this.actions.update]) {
        this.triggerBlockingEvent(this.actions.update, application);
      }
    },
    triggerOpen(application) {
      if (application.permissions[this.actions.view]) {
        this.triggerBlockingEvent(this.actions.view, application);
      }
    },
    async triggerManageOwners(application) {
      if (await this.checkApplicationLock(application) === false) {
        return false;
      }

      if (application.permissions[this.actions.transfer]) {
        this.$emit(this.actions.manage_owners, application);
      }
    },
    triggerAttachment(application) {
      if (application.permissions[this.actions.view]) {
         this.triggerBlockingEvent(this.actions.attachments, application);
      }
    },
    async triggerUpdateStatus(application) {
      if (await this.checkApplicationLock(application) === false) {
        return false;
      }

      if (application.permissions[this.actions.update_status]) {
        this.$emit(this.actions.update_status, application);
      }
    },
    async triggerManageComment(application) {
      if (await this.checkApplicationLock(application) === false) {
        return false;
      }

      if (application.permissions[this.actions.update_status]) {
        this.$emit(this.actions.comment, application);
      }
    },
    triggerCloneApplication(application) {
      if (application.permissions[this.actions.update]) {
        this.$emit(this.actions.clone, application);
      }
    },
    triggerBlockingEvent(action, application) {
      let progress_handler = {
        action: action,
        application: application,
      };

      try {
        this.$emit("update:loading", progress_handler);
        this.$emit(action, application);
      } catch (error){
        console.error(error);
      }
    },
    async triggerRetrieveFromHubspot(application){
      const query = {
        key: "Email",
        query: application.contact_details.email,
      }
      try {
        this.$modal.show(WaitingDialog, {
          title: 'Processing...',
          message: 'Taking you to application page once the application is retrieved.',
        });

        const outcome = await this.$store.dispatch("perform_application_search", query);
        if (outcome) {
          const applications = this.$store.getters.application_search.results;
          if (applications && applications.length > 0) {
            this.$router.push(`/application/${applications[0].id}/capture`);
          }
        }
      } catch(error) {
        console.error('Search request failed');
        console.error(error);
      } finally {
        if (this.$modal.submit) {
          this.$modal.submit();
        }
      }
    },
    isFromHubspot() {
      return this.items.some(item => item.is_from_hubspot == true);
    },
    async checkApplicationLock(application) {
      if (this.userHasPermission('bypass-application-lock') === false
        && await this.$store.dispatch('check_application_lock', application.id) == false) {
        this.$notifications.notify({
          'message': this.current_lock.messages,
          'icon': 'lock',
          'timeout': 5000,
          'verticalAlign': 'top',
          'horizontalAlign': 'center'
        })
        return false
      }
    },
    ...filters,
  },
  filters: {
    ...filters,
  },
  created() {
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/scss/md-custom/_ausloans-colors.scss";
.traffic-light {
  width: 100%;
  height: 100%;
  &.badgrade {
    background: #d9808c;
  }
  &.goodgrade {
    background: #9ddb76;
  }
  &.okaygrade {
    background: #f5cf6e;
  }
}
::v-deep .days_light_green {
  border-left: solid 5px #9ddb76;
}
::v-deep .days_amber {
  border-left: solid 5px #f5cf6e;
}
::v-deep .days_red {
  border-left: solid 5px #d9808c;
}
::v-deep .action-menu .md-button:not(.md-just-icon) .md-ripple .md-button-content i {
    font-size: 1.5rem !important;
}
::v-deep .work-basket-comment {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  &:hover{
  	white-space: normal;
  }
}

::v-deep .work-basket-overflow-item {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  &:hover{
    white-space: revert;
    word-break: break-all;
  }
}

.round-pink-background {
  background-color: #F2006D;
  border-radius: 50%;
  color: white !important;
}
</style>
